export const getApiErrorMessage = (error, fallback) => {
  const message = error?.response?.data?.message;
  return typeof message === 'string' && message.trim() ? message : fallback;
};

export const formatDateTime = value => {
  if (!value) return '—';

  return new Intl.DateTimeFormat(navigator.language, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
};

export const toIsoTimestamp = value => {
  if (!value) return undefined;
  return new Date(value).toISOString();
};

export const isPlainObject = value => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};
